// Client-side session helpers.
//
// The actual credential is the HttpOnly `urltoken` cookie the portal sets at
// login. The frontend never sees it — it just needs to know whether someone
// is "logged in" (so ProtectedRoute can gate) and who they are (for the
// topbar + role-based menu items). That's what we keep in localStorage here.

const KEY = "session";

export function saveSession(user) {
  // user = { _id, email, role, name? }
  const trimmed = {
    _id: user?._id,
    email: user?.email,
    role: user?.role,
    name:
      user?.name ||
      [user?.firstname, user?.lastname].filter(Boolean).join(" ") ||
      user?.email,
  };
  localStorage.setItem(KEY, JSON.stringify(trimmed));
}

export function getSession() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearSession() {
  localStorage.removeItem(KEY);
  // Older versions of the app left these around — clean up so old installs heal.
  localStorage.removeItem("token");
  localStorage.removeItem("email");
  localStorage.removeItem("role");
}
